import { setHiddenCertificateIndustryRelationApi } from "@/api/services/global/master";
import { TGetSpecificSkillCertificateCompanySpecificIndustryOutputDto } from "@/api/services/global/master/dtos/specificSkillCertificate/get-master-specific-skill-certificate-list.dto";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenCertificateIndustryRelationModalProps = {
  hiddenCertificateIndustryRelation?: TGetSpecificSkillCertificateCompanySpecificIndustryOutputDto;
  setHiddenCertificateIndustryRelation: Dispatch<SetStateAction<TGetSpecificSkillCertificateCompanySpecificIndustryOutputDto | undefined>>;
  setSelectedCertificateIndustryRelationRows: React.Dispatch<React.SetStateAction<TGetSpecificSkillCertificateCompanySpecificIndustryOutputDto[]>>;
};

export const HiddenCertificateIndustryRelationModal: FC<THiddenCertificateIndustryRelationModalProps> = ({
  hiddenCertificateIndustryRelation,
  setHiddenCertificateIndustryRelation,
  setSelectedCertificateIndustryRelationRows,
}) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenCertificateIndustryRelation) return;
    try {
      const rs = await setHiddenCertificateIndustryRelationApi(
        toNumber(hiddenCertificateIndustryRelation.specificSkillCertificateId),
        toNumber(hiddenCertificateIndustryRelation.companySpecificIndustryId),
        { isHidden: !hiddenCertificateIndustryRelation.isHidden },
      );
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenCertificateIndustryRelation(undefined);
      setSelectedCertificateIndustryRelationRows((prev) => {
        const arr = prev.map((item) =>
          toNumber(item.id) === toNumber(rs.data.id)
            ? {
                ...item,
                isHidden: rs.data.isHidden,
              }
            : item,
        );
        return arr;
      });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_SPECIFIC_SKILL_CERTIFICATE] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenCertificateIndustryRelation?.isHidden ? "有効の確認" : "無効化の確認"}
      isOpen={!!hiddenCertificateIndustryRelation}
      onClose={() => setHiddenCertificateIndustryRelation(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenCertificateIndustryRelation?.isHidden ? "この行が有効になれますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
